import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ViewInRoomImage } from 'dibs-view-in-room/exports/ViewInRoomImage';
import { ViewInRoomImageCredits } from 'dibs-view-in-room/exports/ViewInRoomImageCredits';

import { SIZES, SRC_SET_WIDTHS } from './constants';

import { type ViewInRoom_user$key } from './__generated__/ViewInRoom_user.graphql';
import { type ViewInRoom_item$key } from './__generated__/ViewInRoom_item.graphql';
import { type ViewInRoom_viewInRoomPhoto$key } from './__generated__/ViewInRoom_viewInRoomPhoto.graphql';

import styles from './ViewInRoom.scss';

const userFragment = graphql`
    fragment ViewInRoom_user on User {
        ...ViewInRoomImage_user
        ...ViewInRoomImageCredits_user
    }
`;

const itemFragment = graphql`
    fragment ViewInRoom_item on Item {
        ...ViewInRoomImage_item
        ...ViewInRoomImageCredits_item
        description
    }
`;

const viewInRoomPhotoFragment = graphql`
    fragment ViewInRoom_viewInRoomPhoto on viewInRoomPhotos {
        ...ViewInRoomImage_viewInRoomPhoto
        ...ViewInRoomImageCredits_viewInRoomPhoto
    }
`;

export const ViewInRoom: FC<{
    user: ViewInRoom_user$key | null | undefined;
    item: ViewInRoom_item$key;
    viewInRoomPhoto: ViewInRoom_viewInRoomPhoto$key;
    mainImagePath: {
        imagePath: string | null;
        masterOrZoomPath: string | null;
    };
}> = ({ user: userRef, item: itemRef, viewInRoomPhoto: viewInRoomPhotoRef, mainImagePath }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const viewInRoomPhoto = useFragment(viewInRoomPhotoFragment, viewInRoomPhotoRef);

    return (
        <>
            <ViewInRoomImage
                showDimensionsOnHover
                useEagerImageLoad={false}
                srcSetSizes={SIZES}
                srcSetWidths={SRC_SET_WIDTHS}
                item={item}
                user={user}
                viewInRoomPhoto={viewInRoomPhoto}
                mainImagePaths={mainImagePath}
                className={styles.viewInRoomImage}
            />
            <ViewInRoomImageCredits item={item} user={user} viewInRoomPhoto={viewInRoomPhoto} />
        </>
    );
};
